import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["src", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-thumbnail", {
      'wrapper-2': $props.srcs.length % 2 === 0 && $props.srcs.length < 5,
      'wrapper-1': $props.srcs.length === 1
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.srcArrays, function (item) {
    return _openBlock(), _createElementBlock("img", {
      class: "c-thumbnail-item",
      src: item.src,
      key: item.key,
      onClick: _withModifiers(function ($event) {
        return $options.handlePreview($props.srcs, item.src);
      }, ["stop"])
    }, null, 8, _hoisted_1);
  }), 128))], 2);
}